const en = {
  "findNearby": "Find nearby",
  "findNearbyBody": "Food, coffee, shops, toilets, parking & charging",
  "eyebrow": "PLAN YOUR NEXT STOP",
  "title": "Journey companion",
  "close": "Close journey companion",
  "onTheWay": "On the way",
  "category_charge": "Charge",
  "category_food": "Food",
  "category_coffee": "Coffee",
  "category_groceries": "Groceries",
  "category_restroom": "Restroom",
  "category_parking": "Parking",
  "route": "Along route",
  "pin": "Around pin",
  "me": "Around me",
  "nearby": "Nearby",
  "area": "Search area",
  "categories": "Stop categories",
  "changeArea": "Change search area",
  "day": "Day",
  "dayNumber": "Day {{number}}",
  "dayOverview": "Open {{title}} overview",
  "start": "Start point",
  "plannedStop": "Planned stop",
  "afterStop": "After stop",
  "end": "End point",
  "noMappedStops": "No mapped stops yet",
  "noLaterPoint": "No later mapped point — choose an earlier start",
  "destination": "Trip destination",
  "retainStops": "Existing stops between these points remain in your route.",
  "section_one": "{{count}} route section",
  "section_other": "{{count}} route sections",
  "needCharge": "Charging is needed before the reserve runs low.",
  "noScope": "Choose two different points with a calculated route. A final stop has no onward route; select an earlier start, or use Around pin.",
  "around": "Around {{place}}",
  "after": "After {{place}}",
  "yourLocation": "your location",
  "selectedStop": "the selected stop",
  "usePlannedStop": "Use planned stop",
  "radius": "Radius",
  "searchRadius": "Search radius",
  "allNetworks": "All charging networks",
  "onlyNetworks": "{{count}} selected networks only",
  "preferredNetworks": "{{count}} preferred networks",
  "anyPower": "Any power · no hidden speed filter",
  "savePreferences": "Save preferences for this trip",
  "saving": "Saving…",
  "preferencesSaved": "Saved for this trip. Your route and stops were not changed.",
  "preferencesError": "Could not save trip preferences. Your current search choices are still available.",
  "batteryWindow": "Search within estimated battery range",
  "batteryWindowInfo": "Searching the first {{distance}} of this route, reserving {{reserve}}% battery. Actual driving to each station is checked separately.",
  "immediateCharge": "Your estimated battery is already near the reserve. Use Around pin to find charging before continuing.",
  "find": "Find stops",
  "finding": "Finding stops…",
  "locating": "Checking location…",
  "recalculating": "Your route is recalculating. Nearby search is still available.",
  "viewer": "You can explore places. An owner or editor can add them to this trip.",
  "emptyTitle": "Choose where to stop next",
  "emptyBody": "Pick a leg or an area, then find real places. Nothing is added until you confirm.",
  "moreAreas": "More route areas or networks remain to check",
  "noResults": "No matching {{category}} returned",
  "pageIncomplete": "This page is not an exhaustive search. Load more below to continue.",
  "broadenHelp": "Places may still exist. Change the selected route or broaden your filters.",
  "broaden": "Broaden to all networks and speeds",
  "searchStart": "Search around start point instead",
  "places": "{{count}} places",
  "compare": "Compare top 3",
  "comparing": "Comparing…",
  "showMap": "Show map",
  "hideMap": "Hide map",
  "collapse": "Collapse",
  "change": "Change",
  "placesFrom": "Places from",
  "placeInformation": "Place information from",
  "attribution": "Availability and opening information can change.",
  "partial": "Some searches failed. These are partial results, not all available stations.",
  "retrySearch": "Retry search",
  "inspect": "Inspect {{title}}",
  "networkMatch": "Network match: {{network}}",
  "networkUnknown": "Network not identified",
  "fromRoute": "{{distance}} from route · not driving detour",
  "preferred": "Preferred",
  "away": "{{distance}} away",
  "maxPower": "Up to {{power}} kW",
  "available": "{{available}}/{{total}} reported available",
  "liveUnknown": "Live availability unknown",
  "checkConnector": "Check connector",
  "arrival": "{{percent}}% arrival",
  "walk": "Walk",
  "drive": "Drive",
  "backPlace": "Back to {{title}}",
  "backResults": "Back to results",
  "reviewsCount": "{{count}} reviews",
  "openNow": "Open now · provider reported",
  "closedNow": "Closed now · provider reported",
  "restroomYes": "Restroom reported",
  "restroomNo": "No restroom reported",
  "liveNotReported": "Live availability not reported",
  "connectors": "{{count}} connectors",
  "connectorsUnknown": "Connector count unavailable",
  "partialConnectors": "Only some connectors report live status.",
  "providerUpdate": "Provider update: {{time}}",
  "compatible": "Connector family matches your vehicle.",
  "incompatible": "Listed connectors do not match your vehicle. Check adapter compatibility before adding.",
  "compatibilityUnknown": "Connector compatibility is not confirmed.",
  "vehicleMax": "Vehicle maximum: {{power}} kW.",
  "loadingDetails": "Loading verified place details…",
  "retryDetails": "Retry place details",
  "routeImpact": "Route impact",
  "gettingThere": "Getting there",
  "checkImpact": "Check route impact",
  "between": "After {{after}}, before {{before}}.",
  "afterOnly": "After {{after}}.",
  "calculating": "Calculating this stop’s driving and battery estimate…",
  "walkTo": "Walk to stop",
  "driveTo": "Drive to stop",
  "distanceTo": "Distance to stop",
  "extraTime": "Extra time",
  "extraDistance": "Extra distance",
  "batteryAtStop": "Battery at this stop",
  "lowReserve": "Estimated arrival is below your {{reserve}}% reserve. Choose an earlier charger or review the plan first.",
  "estimateHelp": "Estimates use your vehicle and route settings, not live vehicle telemetry. Conditions and charger availability can change.",
  "planTarget": "Plan a charge target",
  "leaveTarget": "Leave this charger at",
  "chargeTarget": "Charge target",
  "targetHelp": "Optional; this does not reserve a charger or control the vehicle.",
  "whatsNearby": "What’s nearby?",
  "nearbyHelp": "Search around {{title}}. Nearby places are separate places, not amenities guaranteed at this station.",
  "reviewsOn": "Reviews on",
  "reviewsHelp": "Provider-selected reviews, not necessarily the newest.",
  "visited": "Visited {{date}}",
  "translated": "Translated by Google.",
  "excerpt": "Review excerpt.",
  "fullReview": "Read full review on Google Maps ↗",
  "readReview": "Read on Google Maps ↗",
  "noReviews": "Written reviews were not returned for this place.",
  "checkMaps": "Check Google Maps ↗",
  "added": "{{title}} added",
  "recalculatePlan": "Your plan will recalculate automatically.",
  "continueStop": "Continue from this stop",
  "addPlacement": "Add to Day {{day}}, after {{title}}",
  "addFirst": "Add to Day {{day}} as its first stop",
  "chooseDay": "Choose a trip day before adding.",
  "addAfter": "Add after {{title}}",
  "addDay": "Add to Day {{day}}",
  "viewOnly": "View only — editor access needed",
  "planChanged": "Your plan or vehicle changed. Check the route impact again for a current estimate.",
  "locationUnavailable": "Location is unavailable. Choose Around pin instead.",
  "locationDenied": "Location permission was not available. You can search Around pin without it.",
  "chooseMapped": "Choose a mapped stop, or use Around me to discover your first stop.",
  "chooseEndpoints": "Choose a start and a later end point with a calculated route. For a final stop, search the incoming route or Around pin.",
  "chooseNetwork": "Choose at least one network, or select All networks.",
  "chooseLocation": "Choose Around me to allow location, or search Around pin.",
  "searchError": "Places could not load. Please try again.",
  "impactUnavailable": "Route estimate unavailable for this stop. You can still add the place and calculate its route afterward.",
  "impactError": "Route estimate unavailable.",
  "compareError": "Some route estimates are unavailable. Inspect a place to retry.",
  "detailError": "Extra place details are unavailable.",
  "selectedRouteChanged": "Your selected route changed. Return to the results and choose the route again.",
  "saveError": "Could not confirm the save. Check the plan before retrying.",
  "loadMore": "Load more results",
  "loading": "Loading…",
  "timeUnknown": "Time not reported",
  "dateUnknown": "Date not reported",
  "minutes": "{{minutes}} min",
  "hoursMinutes": "{{hours}} h {{minutes}} min"
};
const tr: Record<keyof typeof en, string> = {
  "findNearby": "Yakında bul",
  "findNearbyBody": "Yemek, kahve, market, tuvalet, park ve şarj",
  "eyebrow": "SIRADAKİ DURAĞINI BUL",
  "title": "Yol arkadaşı",
  "close": "Yol arkadaşını kapat",
  "onTheWay": "Yol üstünde",
  "category_charge": "Şarj",
  "category_food": "Yemek",
  "category_coffee": "Kahve",
  "category_groceries": "Market",
  "category_restroom": "Tuvalet",
  "category_parking": "Otopark",
  "route": "Rota boyunca",
  "pin": "Durak çevresi",
  "me": "Yakınımda",
  "nearby": "Çevrede",
  "area": "Arama alanı",
  "categories": "Durak türleri",
  "changeArea": "Arama alanını değiştir",
  "day": "Gün",
  "dayNumber": "{{number}}. gün",
  "dayOverview": "{{title}} özetini aç",
  "start": "Başlangıç",
  "plannedStop": "Plandaki durak",
  "afterStop": "Başlangıç durağı",
  "end": "Bitiş",
  "noMappedStops": "Henüz haritada durak yok",
  "noLaterPoint": "Sonraki durak yok; daha erken bir başlangıç seç",
  "destination": "Gezi varış noktası",
  "retainStops": "Aradaki mevcut duraklar rotanda kalır.",
  "section_one": "{{count}} rota bölümü",
  "section_other": "{{count}} rota bölümü",
  "needCharge": "Yedek batarya azalmadan şarj gerekiyor.",
  "noScope": "Hesaplanmış rotada iki farklı nokta seç. Son durakta devam rotası yok; daha erken başla ya da Durak çevresini kullan.",
  "around": "{{place}} çevresinde",
  "after": "{{place}} sonrasında",
  "yourLocation": "konumun",
  "selectedStop": "seçili durak",
  "usePlannedStop": "Plandaki durağı kullan",
  "radius": "Arama yarıçapı",
  "searchRadius": "Arama yarıçapı",
  "allNetworks": "Tüm şarj ağları",
  "onlyNetworks": "Yalnızca {{count}} seçili ağ",
  "preferredNetworks": "{{count}} tercih edilen ağ",
  "anyPower": "Her güç seviyesi",
  "savePreferences": "Tercihleri gezi için kaydet",
  "saving": "Kaydediliyor…",
  "preferencesSaved": "Bu gezi için kaydedildi. Rota ve durakların aynı kaldı.",
  "preferencesError": "Tercihler kaydedilemedi. Arama seçimlerin korunuyor; tekrar deneyebilirsin.",
  "batteryWindow": "Tahmini batarya menzilinde ara",
  "batteryWindowInfo": "Rotanın ilk {{distance}} bölümünde, %{{reserve}} batarya yedeğiyle aranıyor. Her istasyona sürüş ayrıca hesaplanır.",
  "immediateCharge": "Tahmini batarya yedek seviyesine yakın. Devam etmeden Durak çevresinde şarj ara.",
  "find": "Durak bul",
  "finding": "Duraklar aranıyor…",
  "locating": "Konum alınıyor…",
  "recalculating": "Rota yeniden hesaplanıyor. Çevrede arama yapabilirsin.",
  "viewer": "Yerleri keşfedebilirsin. Gezi sahibi veya düzenleyici bunları plana ekleyebilir.",
  "emptyTitle": "Sıradaki molanı seç",
  "emptyBody": "Bir alan ve durak türü seç. Seçtiğin yeri onaylayınca plana eklenir.",
  "moreAreas": "Kontrol edilecek başka alanlar veya ağlar var",
  "noResults": "{{category}} için eşleşme bulunamadı",
  "pageIncomplete": "Bu sayfa tüm sonuçları içermiyor. Daha fazla sonuç yükleyebilirsin.",
  "broadenHelp": "Başka yerler olabilir. Arama alanını değiştir veya filtreleri genişlet.",
  "broaden": "Tüm ağlarda ve güçlerde ara",
  "searchStart": "Başlangıç çevresinde ara",
  "places": "{{count}} yer",
  "compare": "İlk 3 yeri karşılaştır",
  "comparing": "Karşılaştırılıyor…",
  "showMap": "Haritayı göster",
  "hideMap": "Haritayı gizle",
  "collapse": "Kapat",
  "change": "Değiştir",
  "placesFrom": "Yer bilgisi:",
  "placeInformation": "Yer bilgisi:",
  "attribution": "Müsaitlik ve çalışma saatleri değişebilir.",
  "partial": "Bazı aramalar tamamlanamadı. Sonuçlar kısmi; tüm istasyonları içermeyebilir.",
  "retrySearch": "Aramayı tekrar dene",
  "inspect": "{{title}} ayrıntıları",
  "networkMatch": "Şarj ağı: {{network}}",
  "networkUnknown": "Şarj ağı belirlenemedi",
  "fromRoute": "Rotaya {{distance}}; sürüş sapması değil",
  "preferred": "Tercih edilen",
  "away": "{{distance}} uzakta",
  "maxPower": "En fazla {{power}} kW",
  "available": "{{available}}/{{total}} müsait bildirildi",
  "liveUnknown": "Canlı müsaitlik bilinmiyor",
  "checkConnector": "Soketi kontrol et",
  "arrival": "Varışta %{{percent}}",
  "walk": "Yürü",
  "drive": "Sürüş",
  "backPlace": "{{title}} konumuna dön",
  "backResults": "Sonuçlara dön",
  "reviewsCount": "{{count}} yorum",
  "openNow": "Şu an açık; sağlayıcı bildirimi",
  "closedNow": "Şu an kapalı; sağlayıcı bildirimi",
  "restroomYes": "Tuvalet var bildirildi",
  "restroomNo": "Tuvalet bilgisi yok",
  "liveNotReported": "Canlı müsaitlik bildirilmedi",
  "connectors": "{{count}} soket",
  "connectorsUnknown": "Soket sayısı bilinmiyor",
  "partialConnectors": "Canlı durum yalnızca bazı soketler için bildiriliyor.",
  "providerUpdate": "Sağlayıcı güncellemesi: {{time}}",
  "compatible": "Soket tipi aracınla eşleşiyor.",
  "incompatible": "Listelenen soketler aracınla eşleşmiyor. Eklemeden önce adaptör uyumunu kontrol et.",
  "compatibilityUnknown": "Soket uyumu doğrulanmadı.",
  "vehicleMax": "Araç en fazla {{power}} kW alabilir.",
  "loadingDetails": "Yer ayrıntıları alınıyor…",
  "retryDetails": "Ayrıntıları tekrar yükle",
  "routeImpact": "Rotaya etkisi",
  "gettingThere": "Buraya ulaşım",
  "checkImpact": "Rotaya etkisini hesapla",
  "between": "{{after}} sonrasında, {{before}} öncesinde.",
  "afterOnly": "{{after}} sonrasında.",
  "calculating": "Bu durak için sürüş ve batarya hesaplanıyor…",
  "walkTo": "Durağa yürüyüş",
  "driveTo": "Durağa sürüş",
  "distanceTo": "Durağa mesafe",
  "extraTime": "Ek süre",
  "extraDistance": "Ek mesafe",
  "batteryAtStop": "Durakta batarya",
  "lowReserve": "Tahmini varış bataryası %{{reserve}} yedeğinin altında. Daha erken bir şarj durağı seç veya planı gözden geçir.",
  "estimateHelp": "Tahminler araç ve rota ayarlarına dayanır. Canlı araç verisi kullanılmaz; yol koşulları ve müsaitlik değişebilir.",
  "planTarget": "Şarj hedefi belirle",
  "leaveTarget": "Bu şarj durağından çıkış",
  "chargeTarget": "Şarj hedefi",
  "targetHelp": "İsteğe bağlı; istasyonu rezerve etmez veya aracı kontrol etmez.",
  "whatsNearby": "Çevrede neler var?",
  "nearbyHelp": "{{title}} çevresinde ara. Bulunan yerler ayrı işletmelerdir; istasyonun olanakları olmayabilir.",
  "reviewsOn": "Yorumlar:",
  "reviewsHelp": "Sağlayıcının seçtiği yorumlar; en yenileri olmayabilir.",
  "visited": "Ziyaret: {{date}}",
  "translated": "Google tarafından çevrildi.",
  "excerpt": "Yorum özeti.",
  "fullReview": "Yorumun tamamını Google Maps’te oku ↗",
  "readReview": "Google Maps’te oku ↗",
  "noReviews": "Bu yer için yazılı yorum alınamadı.",
  "checkMaps": "Google Maps’te bak ↗",
  "added": "{{title}} eklendi",
  "recalculatePlan": "Planın otomatik olarak yeniden hesaplanır.",
  "continueStop": "Bu duraktan devam et",
  "addPlacement": "{{day}}. güne, {{title}} sonrasına ekle",
  "addFirst": "{{day}}. günün ilk durağı olarak ekle",
  "chooseDay": "Eklemeden önce bir gezi günü seç.",
  "addAfter": "{{title}} sonrasına ekle",
  "addDay": "{{day}}. güne ekle",
  "viewOnly": "Görüntüleme erişimi; düzenleme yetkisi gerekli",
  "planChanged": "Plan veya araç değişti. Güncel tahmin için rotaya etkisini tekrar hesapla.",
  "locationUnavailable": "Konum alınamıyor. Durak çevresinde arama yapabilirsin.",
  "locationDenied": "Konum izni alınamadı. İzin vermeden Durak çevresinde arama yapabilirsin.",
  "chooseMapped": "Haritadaki bir durağı seç veya ilk durağını bulmak için Yakınımdayı kullan.",
  "chooseEndpoints": "Hesaplanmış rotada başlangıç ve sonraki bitiş noktasını seç. Son durak için geliş rotasında veya durak çevresinde ara.",
  "chooseNetwork": "En az bir ağ seç veya Tüm ağları kullan.",
  "chooseLocation": "Konum almak için Yakınımdayı seç veya Durak çevresinde ara.",
  "searchError": "Yerler yüklenemedi. Bağlantını kontrol edip tekrar dene.",
  "impactUnavailable": "Bu durak için rota tahmini alınamadı. Yeri ekleyip rotasını sonra hesaplayabilirsin.",
  "impactError": "Rota tahmini alınamadı. Tekrar hesaplayabilirsin.",
  "compareError": "Bazı rota tahminleri alınamadı. Yerin ayrıntılarından tekrar hesaplayabilirsin.",
  "detailError": "Ek yer ayrıntıları alınamadı. Tekrar deneyebilirsin.",
  "selectedRouteChanged": "Seçili rota değişti. Sonuçlara dönüp rotayı tekrar seç.",
  "saveError": "Kayıt doğrulanamadı. Tekrar denemeden planı kontrol et.",
  "loadMore": "Daha fazla sonuç yükle",
  "loading": "Yükleniyor…",
  "timeUnknown": "Saat bildirilmedi",
  "dateUnknown": "Tarih bildirilmedi",
  "minutes": "{{minutes}} dk",
  "hoursMinutes": "{{hours}} sa {{minutes}} dk"
};
const sv: Record<keyof typeof en, string> = {
  "findNearby": "Hitta i närheten",
  "findNearbyBody": "Mat, kaffe, butiker, toaletter, parkering och laddning",
  "eyebrow": "HITTA DITT NÄSTA STOPP",
  "title": "Reskamrat",
  "close": "Stäng reskamraten",
  "onTheWay": "Längs vägen",
  "category_charge": "Laddning",
  "category_food": "Mat",
  "category_coffee": "Kaffe",
  "category_groceries": "Matbutik",
  "category_restroom": "Toalett",
  "category_parking": "Parkering",
  "route": "Längs rutten",
  "pin": "Runt stoppet",
  "me": "Nära mig",
  "nearby": "I närheten",
  "area": "Sökområde",
  "categories": "Stopptyper",
  "changeArea": "Ändra sökområde",
  "day": "Dag",
  "dayNumber": "Dag {{number}}",
  "dayOverview": "Öppna översikt för {{title}}",
  "start": "Startpunkt",
  "plannedStop": "Planerat stopp",
  "afterStop": "Efter stopp",
  "end": "Slutpunkt",
  "noMappedStops": "Inga kartlagda stopp ännu",
  "noLaterPoint": "Ingen senare punkt – välj en tidigare start",
  "destination": "Resans destination",
  "retainStops": "Befintliga stopp mellan punkterna finns kvar i rutten.",
  "section_one": "{{count}} ruttsträcka",
  "section_other": "{{count}} ruttsträckor",
  "needCharge": "Ladda innan batterireserven blir för låg.",
  "noScope": "Välj två olika punkter med en beräknad rutt. Sista stoppet saknar fortsatt rutt; välj en tidigare start eller Runt stoppet.",
  "around": "Runt {{place}}",
  "after": "Efter {{place}}",
  "yourLocation": "din position",
  "selectedStop": "det valda stoppet",
  "usePlannedStop": "Använd planerat stopp",
  "radius": "Sökradie",
  "searchRadius": "Sökradie",
  "allNetworks": "Alla laddnätverk",
  "onlyNetworks": "Endast {{count}} valda nätverk",
  "preferredNetworks": "{{count}} föredragna nätverk",
  "anyPower": "Alla effektnivåer",
  "savePreferences": "Spara inställningar för resan",
  "saving": "Sparar…",
  "preferencesSaved": "Sparat för resan. Rutten och stoppen är oförändrade.",
  "preferencesError": "Inställningarna kunde inte sparas. Dina sökval finns kvar; försök igen.",
  "batteryWindow": "Sök inom uppskattad batteriräckvidd",
  "batteryWindowInfo": "Söker längs ruttens första {{distance}} med {{reserve}} % batterireserv. Körningen till varje station beräknas separat.",
  "immediateCharge": "Batteriet uppskattas redan vara nära reserven. Sök laddning runt stoppet innan du fortsätter.",
  "find": "Hitta stopp",
  "finding": "Söker stopp…",
  "locating": "Hämtar position…",
  "recalculating": "Rutten beräknas om. Sökning i närheten är fortfarande tillgänglig.",
  "viewer": "Du kan utforska platser. En ägare eller redigerare kan lägga till dem.",
  "emptyTitle": "Välj nästa stopp",
  "emptyBody": "Välj område och stopptyp. Platsen läggs till när du bekräftar.",
  "moreAreas": "Fler områden eller nätverk återstår att söka",
  "noResults": "Inga matchande platser för {{category}} hittades",
  "pageIncomplete": "Sökningen är inte fullständig. Ladda fler resultat för att fortsätta.",
  "broadenHelp": "Det kan finnas fler platser. Ändra område eller bredda filtren.",
  "broaden": "Sök alla nätverk och effekter",
  "searchStart": "Sök runt startpunkten",
  "places": "{{count}} platser",
  "compare": "Jämför de 3 första",
  "comparing": "Jämför…",
  "showMap": "Visa karta",
  "hideMap": "Dölj karta",
  "collapse": "Fäll ihop",
  "change": "Ändra",
  "placesFrom": "Platser från",
  "placeInformation": "Platsinformation från",
  "attribution": "Tillgänglighet och öppettider kan ändras.",
  "partial": "Vissa sökningar misslyckades. Resultaten är ofullständiga.",
  "retrySearch": "Försök söka igen",
  "inspect": "Granska {{title}}",
  "networkMatch": "Nätverk: {{network}}",
  "networkUnknown": "Nätverket är okänt",
  "fromRoute": "{{distance}} från rutten; inte körsträcka för omvägen",
  "preferred": "Föredragen",
  "away": "{{distance}} bort",
  "maxPower": "Upp till {{power}} kW",
  "available": "{{available}}/{{total}} rapporteras lediga",
  "liveUnknown": "Aktuell tillgänglighet är okänd",
  "checkConnector": "Kontrollera kontakten",
  "arrival": "{{percent}} % vid ankomst",
  "walk": "Gå",
  "drive": "Körning",
  "backPlace": "Tillbaka till {{title}}",
  "backResults": "Tillbaka till resultaten",
  "reviewsCount": "{{count}} recensioner",
  "openNow": "Öppet nu enligt leverantören",
  "closedNow": "Stängt nu enligt leverantören",
  "restroomYes": "Toalett rapporterad",
  "restroomNo": "Ingen toalett rapporterad",
  "liveNotReported": "Aktuell tillgänglighet saknas",
  "connectors": "{{count}} kontakter",
  "connectorsUnknown": "Antalet kontakter är okänt",
  "partialConnectors": "Bara vissa kontakter rapporterar aktuell status.",
  "providerUpdate": "Leverantörens uppdatering: {{time}}",
  "compatible": "Kontakttypen matchar ditt fordon.",
  "incompatible": "Kontakterna matchar inte fordonet. Kontrollera adapterkompatibilitet innan du lägger till.",
  "compatibilityUnknown": "Kontaktkompatibiliteten är inte bekräftad.",
  "vehicleMax": "Fordonets maxeffekt: {{power}} kW.",
  "loadingDetails": "Hämtar platsinformation…",
  "retryDetails": "Hämta platsinformationen igen",
  "routeImpact": "Ruttpåverkan",
  "gettingThere": "Ta dig dit",
  "checkImpact": "Beräkna ruttpåverkan",
  "between": "Efter {{after}}, före {{before}}.",
  "afterOnly": "Efter {{after}}.",
  "calculating": "Beräknar körning och batteri för stoppet…",
  "walkTo": "Gång till stoppet",
  "driveTo": "Körning till stoppet",
  "distanceTo": "Avstånd till stoppet",
  "extraTime": "Extra tid",
  "extraDistance": "Extra sträcka",
  "batteryAtStop": "Batteri vid stoppet",
  "lowReserve": "Batteriet vid ankomst uppskattas under {{reserve}} % reserv. Välj en tidigare laddare eller granska planen.",
  "estimateHelp": "Uppskattningar använder fordons- och ruttinställningar. Ingen direkt fordonsdata används; förhållanden och tillgänglighet kan ändras.",
  "planTarget": "Planera laddmål",
  "leaveTarget": "Lämna laddaren med",
  "chargeTarget": "Laddmål",
  "targetHelp": "Valfritt; det bokar inte laddaren och styr inte fordonet.",
  "whatsNearby": "Vad finns i närheten?",
  "nearbyHelp": "Sök runt {{title}}. Platserna är separata verksamheter och inte garanterade tjänster på stationen.",
  "reviewsOn": "Recensioner på",
  "reviewsHelp": "Recensioner valda av leverantören; inte nödvändigtvis de senaste.",
  "visited": "Besökt {{date}}",
  "translated": "Översatt av Google.",
  "excerpt": "Utdrag ur recension.",
  "fullReview": "Läs hela recensionen på Google Maps ↗",
  "readReview": "Läs på Google Maps ↗",
  "noReviews": "Inga skrivna recensioner returnerades för platsen.",
  "checkMaps": "Se på Google Maps ↗",
  "added": "{{title}} har lagts till",
  "recalculatePlan": "Planen beräknas om automatiskt.",
  "continueStop": "Fortsätt från stoppet",
  "addPlacement": "Lägg till på dag {{day}}, efter {{title}}",
  "addFirst": "Lägg till som första stopp på dag {{day}}",
  "chooseDay": "Välj en resdag innan du lägger till.",
  "addAfter": "Lägg till efter {{title}}",
  "addDay": "Lägg till på dag {{day}}",
  "viewOnly": "Endast visning – redigerarbehörighet krävs",
  "planChanged": "Planen eller fordonet ändrades. Beräkna ruttpåverkan igen för en aktuell uppskattning.",
  "locationUnavailable": "Positionen är inte tillgänglig. Sök runt stoppet istället.",
  "locationDenied": "Platsbehörighet saknas. Du kan söka runt stoppet utan den.",
  "chooseMapped": "Välj ett kartlagt stopp eller använd Nära mig för att hitta ditt första stopp.",
  "chooseEndpoints": "Välj en start och en senare slutpunkt med en beräknad rutt. För sista stoppet kan du söka inkommande rutt eller runt stoppet.",
  "chooseNetwork": "Välj minst ett nätverk eller Alla nätverk.",
  "chooseLocation": "Välj Nära mig för att hämta positionen eller sök runt stoppet.",
  "searchError": "Platserna kunde inte hämtas. Kontrollera anslutningen och försök igen.",
  "impactUnavailable": "Ruttuppskattningen saknas för stoppet. Du kan lägga till platsen och beräkna rutten efteråt.",
  "impactError": "Ruttuppskattningen saknas. Försök beräkna igen.",
  "compareError": "Vissa ruttuppskattningar saknas. Öppna en plats för att försöka igen.",
  "detailError": "Ytterligare platsinformation saknas. Försök igen.",
  "selectedRouteChanged": "Den valda rutten ändrades. Gå tillbaka och välj rutten igen.",
  "saveError": "Kunde inte bekräfta att stoppet sparats. Kontrollera planen innan du försöker igen.",
  "loadMore": "Ladda fler resultat",
  "loading": "Laddar…",
  "timeUnknown": "Tid saknas",
  "dateUnknown": "Datum saknas",
  "minutes": "{{minutes}} min",
  "hoursMinutes": "{{hours}} tim {{minutes}} min"
};
export const journeyTranslations = { en, tr, sv };
